import script from "./LogoutDialogues.vue?vue&type=script&setup=true&lang=ts"
export * from "./LogoutDialogues.vue?vue&type=script&setup=true&lang=ts"

import "./LogoutDialogues.vue?vue&type=style&index=0&id=7095265e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7095265e"]])

export default __exports__